import { AGENCY_SALES_EDIT, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_LOAD_DATA, AGENCY_QUOTATION_PREM_LOADING, AGENCY_QUOTATION_PREM_SUCCESS, AGENCY_QUOTATION_PREM_FAIL, AGENCY_QUOTATION_LEAVEQUOTE, AGENCY_QUOTATION_COMMSLOG, AGENCY_QUOTATION_DISCADJ } from '@/store/types'
import { appID } from '@/const/underwriting'
import { initialState } from '@/store/modules/agency'
import clone from 'clone'
import Vue from 'vue'

export const quote = {
  [AGENCY_SALES_EDIT](state, data) {
    state.quotation.commonForm.salesOppName = data.name
    state.quotation.commonForm.salesOppEmail = data.email
    state.quotation.commonForm.salesOppPhone = data.phone
  },
  [AGENCY_QUOTATION_SAVE_LOADING](state) {
    state.quotation.saving = true
    state.quotation.saveError.fieldMessages = []
    state.quotation.saveError.messages = []
  },
  [AGENCY_QUOTATION_SAVE_SUCCESS](state) {
    state.quotation.saving = false
    state.quotation.saveError.fieldMessages = []
    state.quotation.saveError.messages = []
  },
  [AGENCY_QUOTATION_SAVE_FAIL](state, errMsgs) {
    state.quotation.saving = false
    state.quotation.saveError.fieldMessages = errMsgs.fieldMessages
    state.quotation.saveError.messages = errMsgs.messages
  },
  [AGENCY_QUOTATION_LOAD_DATA](state, fullData) {
    if (fullData.partialSave) {
      // For normal saving, we just want to update the revision no to prevent locking
      const { data } = fullData
      state.quotation.commonForm.revision = data.revision
    } else {
      const { data, query, menu } = fullData
      // General Data
      if (state.quotation.quoteLifeCycle === 0 && !query) {
        // If its 0, its coming from sales opp. Change it to 1 to kick start the flow
        state.quotation.quoteLifeCycle = 1
      }

      // Proposal Level
      commitProposal(state, data)

      // Query Specifics
      commitQuery(state, data)

      // Risk Specifics
      if (data.appID === appID.MOTOR) {
        commitMotor(state, data)
      } else if (data.appID === appID.CARGO) {
        commitCargo(state, data)
      } else if (data.appID === appID.FIRE) {
        commitFire(state, data)
      } else if (data.appID === appID.MAID) {
        commitMaid(state, data)
      } else if (data.appID === appID.TRAVEL) {
        commitTravel(state, data)
      } else if (data.appID === appID.PACKAGE) {
        commitPackage(state, data)
      } else if (data.appID === appID.PA) {
        commitPA(state, data)
      }

      // Menu (For query)
      if (menu) {
        state.quotationSettings.menu = menu
      }
    }
  },
  [AGENCY_QUOTATION_LIFECYCLE](state, data) {
    state.quotation.quoteLifeCycle = data
  },
  [AGENCY_QUOTATION_PREM_LOADING](state) {
    state.quotation.commonInfo.premium = clone(initialState.quotation.commonInfo.premium)
    state.quotation.commonInfo.premium.init = 0
  },
  [AGENCY_QUOTATION_PREM_SUCCESS](state, data) {
    const { premium } = state.quotation.commonInfo
    premium.init = 1
    commitPremium(state, data)
  },
  [AGENCY_QUOTATION_PREM_FAIL](state, errs) {
    state.quotation.commonInfo.premium = clone(initialState.quotation.commonInfo.premium)
    state.quotation.commonInfo.premium.init = 2
    state.quotation.commonInfo.premium.initErr = errs
  },
  [AGENCY_QUOTATION_LEAVEQUOTE](state) {
    state.quotation.promptWhenExit = false
  },
  [AGENCY_QUOTATION_COMMSLOG](state, data) {
    Vue.set(state.quotation.commonInfo, 'commsLogs', data)
  },
  [AGENCY_QUOTATION_DISCADJ](state, data) {
    state.quotation.commonForm.adjDiscount = data
  }
}

const commitProposal = (state, data) => {
  const { commonForm } = state.quotation
  commonForm.proposalNo = data.proposalNo
  commonForm.revision = data.revision
  commonForm.appID = data.appID
  commonForm.intermediary = data.inter
  commonForm.finInst = data.finInst
  commonForm.salesOppName = data.salesOppName
  commonForm.salesOppEmail = data.salesOppEmail
  commonForm.salesOppPhone = data.salesOppPhone
  commonForm.product = data.product
  commonForm.scheme = data.scheme
  commonForm.duration = data.duration
  commonForm.startDate = data.comDate
  commonForm.endDate = data.expDate
  commonForm.campaign = data.campaign
  commonForm.promotion = data.promotion
  commonForm.adjDiscount = data.adjDiscount
  commonForm.billCurr = data.billCurr
  commonForm.billCurrRate = data.billCurrRate
  commonForm.acceptDate = data.acceptDate
  commonForm.optCvr = data.optCvr
  commonForm.discLdg = data.discLdg
  commonForm.paytMode = data.paytMode
  commonForm.paytCCNo = data.paytCCNo
  commonForm.paytCCName = data.paytCCName
  commonForm.paytCCType = data.paytCCType
  commonForm.paytCCExpMth = data.paytCCExpMth
  commonForm.paytCCExpYr = data.paytCCExpYr
  commonForm.paytCCCvv = data.paytCCCvv
  commonForm.paytInstalmentPlan = data.paytInstalmentPlan

  commonForm.applicant.appIntStat = data.appIntStat
  commonForm.applicant.appSalutation = data.appSalutation
  commonForm.applicant.appMaritalStatus = data.appMaritalStatus
  commonForm.applicant.appName = data.appName
  commonForm.applicant.appNationality = data.appNationality
  commonForm.applicant.appNricPassport = data.appNricPassport
  commonForm.applicant.appDob = data.appDob
  commonForm.applicant.appGender = data.appGender
  commonForm.applicant.appOccupation = data.appOccupation
  commonForm.applicant.appEmployerName = data.appEmployerName
  commonForm.applicant.appJointApplicant = data.appJointApplicant
  commonForm.applicant.appJointScheme = data.appJointScheme
  commonForm.applicant.appEmail = data.appEmail
  commonForm.applicant.appMobileNo = data.appMobileNo
  commonForm.applicant.appTelNo1 = data.appTelNo1
  commonForm.applicant.appTelNo2 = data.appTelNo2
  commonForm.applicant.appFaxNo = data.appFaxNo
  commonForm.applicant.appPostalCode = data.appPostalCode
  commonForm.applicant.appAdd1 = data.appAdd1
  commonForm.applicant.appAdd2 = data.appAdd2
  commonForm.applicant.appAdd3 = data.appAdd3
  commonForm.applicant.appAdd4 = data.appAdd4
  commonForm.applicant.appState = data.appState
  commonForm.applicant.appCountry = data.appCountry
  commonForm.applicant.mailAdd = data.mailAdd
  commonForm.applicant.mailPostalCode = data.mailPostalCode
  commonForm.applicant.mailAdd1 = data.mailAdd1
  commonForm.applicant.mailAdd2 = data.mailAdd2
  commonForm.applicant.mailAdd3 = data.mailAdd3
  commonForm.applicant.mailAdd4 = data.mailAdd4
  commonForm.applicant.mailState = data.mailState
  commonForm.applicant.mailCountry = data.mailCountry
  commonForm.applicant.coyName = data.coyName
  commonForm.applicant.coyName2 = data.coyName2
  commonForm.applicant.coyRocUen = data.coyRocUen
  commonForm.applicant.coyNature = data.coyNature
  commonForm.applicant.appIsDrv = data.appIsDrv
  commonForm.applicant.appIsStudent = data.appIsStudent
  commonForm.applicant.appIsInsured = data.appIsInsured

  const { commonInfo } = state.quotation
  commonInfo.polNo = data.polNo
  commonInfo.polNo2 = data.polNo2
  commonInfo.proposalRefNo = data.proposalRefNo
  commonInfo.paid = data.paid
  commonInfo.statusCode = data.status
  commonInfo.statuses = data.statuses
  commonInfo.audits = data.audits
  commonInfo.commsLogs = data.commsLogs
  commonInfo.paymentHistory = data.paymentHistory

  commonForm.quotationType = data.quotationType
  commonForm.masterProposalNo = data.masterProposalNo
}

const commitQuery = (state, data) => {
  const { queryInfo } = state.quotation
  const { query } = data

  // General
  queryInfo.intermediary = query.inter
  queryInfo.finInst = query.finInst
  queryInfo.appCountry = query.appCountry
  queryInfo.mailCountry = query.mailCountry
  queryInfo.product = query.product
  queryInfo.scheme = query.scheme
  queryInfo.duration = query.duration
  queryInfo.busCls = query.busCls
  queryInfo.tariff = query.tariff
  queryInfo.cover = query.cover
  queryInfo.campaign = query.campaign
  queryInfo.promotion = query.promotion
  queryInfo.discLdg = query.discLdg

  // Motor
  queryInfo.vehUsg = query.vehUsg
  queryInfo.vehMake = query.vehMake
  queryInfo.vehModel = query.vehModel
  queryInfo.vehBodyType = query.vehBodyType
  queryInfo.vehCapacity = query.vehCapacity
  queryInfo.vehTonnage = query.vehTonnage
  queryInfo.vehNoSeats = query.vehNoSeats
  queryInfo.mtrPlan = query.mtrPlan
  queryInfo.statistics = query.statistics
  queryInfo.excess = query.excess
  queryInfo.permStatuses = query.permStatuses

  // Cargo
  queryInfo.comdty = query.comdty
  queryInfo.pack = query.pack
  queryInfo.convy = query.convy
  queryInfo.vesName = query.vesName
  queryInfo.grt = query.grt
  queryInfo.nrt = query.nrt
  queryInfo.voyDet = query.voyDet
  queryInfo.voyDateType = query.voyDateType
  queryInfo.voyArea = query.voyArea
  queryInfo.portFrom = query.portFrom
  queryInfo.portTo = query.portTo
  queryInfo.surveyAgt = query.surveyAgt
  queryInfo.settlingAgt = query.settlingAgt
  queryInfo.csgnCountry = query.csgnCountry
  queryInfo.crgoCover = query.crgoCover
  queryInfo.clauses = query.clauses

  // Pkg
  queryInfo.plan = query.plan
  queryInfo.limitsText = query.limitsText
  queryInfo.appIDs = query.appIDs

  // Fire
  queryInfo.constrnCls = query.constrnCls
  queryInfo.occupancy = query.occupancy

  // Travel
  queryInfo.travelArea = query.travelArea
}

const commitMotor = (state, data) => {
  const { motorForm } = state.quotation
  let motor = data.motor
  if (!motor || motor === null) {
    motor = {}
  }

  motorForm.busCls = motor.busCls
  motorForm.tariff = motor.tariff
  motorForm.cover = motor.cover
  motorForm.ncdRate = motor.ncbYr
  motorForm.ncdPct = motor.ncbPct
  motorForm.exClm = motor.exClm
  motorForm.noClm = motor.noClm
  motorForm.clmAmt = motor.clmAmt
  motorForm.vehRegNo = motor.vehRegNo
  motorForm.vehUsg = motor.vehUsg
  motorForm.vehMake = motor.vehMake
  motorForm.vehModel = motor.vehModel
  motorForm.vehManuYr = motor.vehManuYr
  motorForm.vehValue = motor.vehValue
  motorForm.vehRegMth = motor.vehRegMth
  motorForm.vehRegYr = motor.vehRegYr
  motorForm.maxLaden = motor.maxLaden
  motorForm.unLaden = motor.unLaden
  motorForm.calcTonnage = motor.calcTonnage
  motorForm.mtrPlan = motor.mtrPlan
  motorForm.engineNo = motor.engineNo
  motorForm.chassisNo = motor.chassisNo
  motorForm.exInsurer = motor.exInsurer
  motorForm.exPolNo = motor.exPolNo
  motorForm.exPolNoExp = motor.exPolNoExp

  // Drivers
  if (motor.drivers && motor.drivers.length > 0) {
    motorForm.drivers = motor.drivers
  } else {
    motorForm.drivers = []
  }
  // Stats
  if (motor.statistics && motor.statistics.length > 0) {
    motorForm.statistics = motor.statistics
  } else {
    motorForm.statistics = []
  }
  // Excess
  if (motor.excess && motor.excess.length > 0) {
    motorForm.excess = motor.excess
  } else {
    motorForm.excess = []
  }

  // Additional Benefits
  // Only certain status will lead to saving of benefits
  if (data.status === 'NQ' || data.status === 'QPA') {
    if (motor.premiumSummary.benefits && motor.premiumSummary.benefits.length > 0) {
      motorForm.addBenefits = []
      for (let benefit of motor.premiumSummary.benefits) {
        // By this stage, we do not know which benefits are addBen
        // We will push all into addBenefits
        // (action - motorQuoteAddBenefits will filter extras out after leaving quotation 1st screen)
        // As for places like query etc, it will know display out addBens anyway
        motorForm.addBenefits.push(benefit.value)
      }
    }
  }
  // Benefits/Premium Specifics
  commitPremium(state, motor.premiumSummary)
}

const commitFire = (state, data) => {
  const { fireForm } = state.quotation
  let fire = data.fire
  if (!fire || fire === null) {
    fire = {}
  }

  fireForm.planNo = fire.planNo
  fireForm.riskAdd = fire.riskAdd
  fireForm.riskAdd1 = fire.riskAdd1
  fireForm.riskAdd2 = fire.riskAdd2
  fireForm.riskAdd3 = fire.riskAdd3
  fireForm.riskAdd4 = fire.riskAdd4
  fireForm.riskPostalCode = fire.riskPostalCode
  fireForm.constrnCls = fire.constrnCls
  fireForm.occupancy = fire.occupancy

  commitPkgPremium(state, fire.premiumSummary)
}

const commitMaid = (state, data) => {
  const { maidForm } = state.quotation
  let maid = data.maid
  if (!maid || maid === null) {
    maid = {}
  }

  maidForm.planNo = maid.planNo
  maidForm.gtSalutation = maid.gtSalutation
  maidForm.gtName = maid.gtName
  maidForm.gtNationality = maid.gtNationality
  maidForm.gtNric = maid.gtNric
  maidForm.gtDob = maid.gtDob
  maidForm.gtGender = maid.gtGender
  maidForm.gtOccupation = maid.gtOccupation
  maidForm.gtEmployerName = maid.gtEmployerName
  maidForm.gtEstAnnualIncome = maid.gtEstAnnualIncome
  maidForm.gtEmail = maid.gtEmail
  maidForm.gtMobileNo = maid.gtMobileNo
  maidForm.gtTelNo1 = maid.gtTelNo1
  maidForm.gtTelNo2 = maid.gtTelNo2
  maidForm.gtAdd = maid.gtAdd
  maidForm.gtPostalCode = maid.gtPostalCode
  maidForm.gtAdd1 = maid.gtAdd1
  maidForm.gtAdd2 = maid.gtAdd2
  maidForm.gtAdd3 = maid.gtAdd3
  maidForm.gtAdd4 = maid.gtAdd4

  maidForm.fwTransNo = maid.fwTransNo
  maidForm.fwName = maid.fwName
  maidForm.fwNationality = maid.fwNationality
  maidForm.fwPassport = maid.fwPassport
  maidForm.fwDob = maid.fwDob
  maidForm.fwGender = maid.fwGender
  maidForm.fwWPNo = maid.fwWPNo
  maidForm.fwWPType = maid.fwWPType

  commitPkgPremium(state, maid.premiumSummary)
}

const commitTravel = (state, data) => {
  const { travelForm } = state.quotation
  let travel = data.travel
  if (!travel || travel === null) {
    travel = {}
  }
  travelForm.tripType = travel.tripType
  travelForm.travelArea = travel.travelArea
  travelForm.noAdult = travel.noAdult
  travelForm.noChild = travel.noChild
  travelForm.planNo = travel.planNo
  travelForm.travelType = travel.travelType

  // Insureds
  if (travel.insureds && travel.insureds.length > 0) {
    travelForm.insureds = travel.insureds
  } else {
    travelForm.insureds = []
  }

  commitPkgPremium(state, travel.premiumSummary)
}

const commitPA = (state, data) => {
  const { paForm, commonForm } = state.quotation
  let pa = data.pa
  if (!pa || pa === null) {
    pa = {}
  }
  commonForm.scheme = data.scheme
  commonForm.schemeDesc = data.schemeDesc
  paForm.noAdult = pa.noAdult
  paForm.noChild = pa.noChild
  paForm.planNo = pa.planNo
  paForm.paType = pa.paType

  // Insureds
  if (pa.insureds && pa.insureds.length > 0) {
    paForm.insureds = pa.insureds
  } else {
    paForm.insureds = []
  }
  commitPkgPremium(state, pa.premiumSummary)
}

const commitPackage = (state, data) => {
  const { packageForm } = state.quotation
  let pkg = data.pkg
  if (!pkg || pkg === null) {
    pkg = {}
  }

  packageForm.planNo = pkg.planNo
  packageForm.siAdjustment = pkg.siAdjustment

  // Fire Risk
  const { fireForm } = state.quotation
  fireForm.riskAdd = pkg.riskAdd
  fireForm.riskAdd1 = pkg.riskAdd1
  fireForm.riskAdd2 = pkg.riskAdd2
  fireForm.riskAdd3 = pkg.riskAdd3
  fireForm.riskAdd4 = pkg.riskAdd4
  fireForm.riskPostalCode = pkg.riskPostalCode

  commitPkgPremium(state, pkg.premiumSummary)
}

const commitCargo = (state, data) => {
  const { cargoForm } = state.quotation
  let cargo = data.cargo
  if (!cargo || cargo === null) {
    cargo = {}
  }

  cargoForm.busCls = cargo.busCls
  cargoForm.tariff = cargo.tariff
  cargoForm.comdty = cargo.comdty
  cargoForm.pack = cargo.pack
  cargoForm.si = cargo.si
  cargoForm.siDeclared = cargo.siDeclared
  cargoForm.siBalance = cargo.siBalance
  cargoForm.printSi = cargo.printSi
  cargoForm.siCurr = cargo.siCurr
  cargoForm.siCurrRate = cargo.siCurrRate
  cargoForm.tolerance = cargo.tolerance
  cargoForm.siUplift = cargo.siUplift
  cargoForm.subjectMatter = cargo.subjectMatter
  cargoForm.convy = cargo.convy
  cargoForm.lcNo = cargo.lcNo
  cargoForm.vesNo = cargo.vesNo
  cargoForm.voyNo = cargo.voyNo
  cargoForm.voyDateType = cargo.voyDateType
  cargoForm.voyDate = cargo.voyDate
  cargoForm.voyArea = cargo.voyArea
  cargoForm.portFrom = cargo.portFrom
  cargoForm.portTo = cargo.portTo
  cargoForm.voyDesc = cargo.voyDesc
  cargoForm.csgnName = cargo.csgnName
  cargoForm.surveyAgt = cargo.surveyAgt
  cargoForm.settlingAgt = cargo.settlingAgt
  cargoForm.clmPayAt = cargo.clmPayAt
  cargoForm.csgnName = cargo.csgnName
  cargoForm.csgnAdd1 = cargo.csgnAdd1
  cargoForm.csgnAdd2 = cargo.csgnAdd2
  cargoForm.csgnAdd3 = cargo.csgnAdd3
  cargoForm.csgnAdd4 = cargo.csgnAdd4
  cargoForm.cover = cargo.cover
  cargoForm.finInstDesc = cargo.finInstDesc
  cargoForm.finInstDesc2 = cargo.finInstDesc2

  // Clause
  if (cargo.clause && cargo.clause.length > 0) {
    cargoForm.clause = cargo.clause
  } else {
    cargoForm.clause = []
  }

  // Benefits/Premium Specifics
  commitPremium(state, cargo.premiumSummary)
  cargoForm.manualRate = []
  if (cargo.premiumSummary.benefits && cargo.premiumSummary.benefits.length > 0) {
    for (let benefit of cargo.premiumSummary.benefits) {
      cargoForm.manualRate.push({
        key: benefit.value,
        value: benefit.rate
      })
    }
  }
}

const commitPremium = (state, data) => {
  const { premium } = state.quotation.commonInfo
  premium.premDue = data.premDue
  premium.discPct = data.discPct
  premium.discPctMax = data.discPctMax
  premium.discAmt = data.discAmt
  premium.netPremDue = data.netPremDue
  premium.gstRate = data.gstRate
  premium.gstAmt = data.gstAmt
  premium.premiumPayable = data.premiumPayable
  premium.billPremiumPayable = data.billPremiumPayable
  premium.commGN = data.commGN
  premium.commRate = data.commRate
  premium.commRateMax = data.commRateMax
  premium.commAmt = data.commAmt
  premium.protDisc = data.protDisc
  premium.protComm = data.protComm
  premium.inclGst = data.inclGst
  premium.benefits = data.benefits
}

export const commitPkgPremium = (state, data) => {
  const { premium } = state.quotation.commonInfo
  if (data) {
    // Combine benefits
    premium.benefits = []
    if (data.riskPrem && data.riskPrem.length > 0) {
      for (const riskPrem of data.riskPrem) {
        if (riskPrem.benefits && riskPrem.benefits.length > 0) {
          premium.benefits.push(...riskPrem.benefits)
        }
      }
    }
    premium.commAmt = data.commAmt
    premium.commGN = data.commGN
    premium.commRate = data.commRate
    premium.commRateMax = data.commRateMax
    premium.discAmt = data.discAmt
    premium.discPct = data.discPct
    premium.discPctMax = data.discPctMax
    premium.gstAmt = data.gstAmt
    premium.gstRate = undefined
    premium.netPremDue = data.netPremDue
    premium.premDue = data.premDue
    premium.premiumPayable = data.premiumPayable
    premium.protDisc = data.protDisc
    premium.protComm = data.protComm
    premium.inclGst = data.inclGst
    premium.promotion = data.promotion
  } else {
    premium.benefits = []
    premium.commAmt = undefined
    premium.commGN = undefined
    premium.commRate = undefined
    premium.commRateMax = undefined
    premium.discAmt = undefined
    premium.discPct = undefined
    premium.discPctMax = undefined
    premium.gstAmt = undefined
    premium.gstRate = undefined
    premium.netPremDue = undefined
    premium.premDue = undefined
    premium.premiumPayable = undefined
    premium.protDisc = undefined
    premium.protComm = undefined
    premium.inclGst = undefined
    premium.promotion = undefined
  }
}
